import { doApi } from './apiClient';
import type { WrestlerStats, PaginatedResponse, ApiError } from '../types';

interface StatsResponse {
  [key: string]: unknown;
}

export const apiGetStats = async (
  year: string | number = 'globale'
): Promise<StatsResponse | ApiError> => {
  try {
    const path = year === 'globale' ? 'api/stats' : `api/stats?year=${year}`;
    return await doApi<StatsResponse>(path, 'GET');
  } catch (error) {
    console.error('Error fetching stats:', error);
    return {
      error: true,
      message: 'Errore nel recupero delle statistiche',
    };
  }
};

export const apiGetBestWrestlerListStats = async (
  page: number = 1,
  year: string | number = 'globale',
  searchText: string = '',
  isAll: boolean = false
): Promise<PaginatedResponse<WrestlerStats> | ApiError> => {
  try {
    let path =
      year === 'globale'
        ? `api/stats/bestWrestler?page=${page}`
        : `api/stats/bestWrestler?year=${year}&page=${page}`;
    if (searchText) {
      path += `&name=${searchText}`;
    }
    if (isAll) {
      path += `&is_all=true`;
    }
    return await doApi<PaginatedResponse<WrestlerStats>>(path, 'GET');
  } catch (error) {
    console.error('Error fetching best wrestlers stats:', error);
    return {
      error: true,
      message: 'Errore nel recupero delle statistiche dei migliori wrestler',
    };
  }
};

export const apiGetBestWrestlerWomanListStats = async (
  page: number = 1,
  year: string | number = 'globale',
  searchText: string = '',
  isAll: boolean = false
): Promise<PaginatedResponse<WrestlerStats> | ApiError> => {
  try {
    let path =
      year === 'globale'
        ? `api/stats/bestWrestlerWoman?page=${page}`
        : `api/stats/bestWrestlerWoman?year=${year}&page=${page}`;
    if (searchText) {
      path += `&name=${searchText}`;
    }
    if (isAll) {
      path += `&is_all=true`;
    }
    return await doApi<PaginatedResponse<WrestlerStats>>(path, 'GET');
  } catch (error) {
    console.error('Error fetching best wrestlers stats:', error);
    return {
      error: true,
      message: 'Errore nel recupero delle statistiche dei migliori wrestler',
    };
  }
};

export const apiGetMostWinsWrestlerListStats = async (
  page: number = 1,
  year: string | number = 'globale',
  searchText: string = ''
): Promise<PaginatedResponse<WrestlerStats> | ApiError> => {
  try {
    let path =
      year === 'globale'
        ? `api/stats/moreWins?page=${page}`
        : `api/stats/moreWins?year=${year}&page=${page}`;
    if (searchText) {
      path += `&name=${searchText}`;
    }
    return await doApi<PaginatedResponse<WrestlerStats>>(path, 'GET');
  } catch (error) {
    console.error('Error fetching most wins wrestlers stats:', error);
    return {
      error: true,
      message: 'Errore nel recupero delle statistiche dei wrestler con più vittorie',
    };
  }
};

export const apiGetMostWinsWrestlerWomanListStats = async (
  page: number = 1,
  year: string | number = 'globale',
  searchText: string = ''
): Promise<PaginatedResponse<WrestlerStats> | ApiError> => {
  try {
    let path =
      year === 'globale'
        ? `api/stats/moreWinsWoman?page=${page}`
        : `api/stats/moreWinsWoman?year=${year}&page=${page}`;
    if (searchText) {
      path += `&name=${searchText}`;
    }
    return await doApi<PaginatedResponse<WrestlerStats>>(path, 'GET');
  } catch (error) {
    console.error('Error fetching most wins wrestlers stats:', error);
    return {
      error: true,
      message: 'Errore nel recupero delle statistiche dei wrestler con più vittorie',
    };
  }
};

export const apiGetMostMatchesWrestlerListStats = async (
  page: number = 1,
  year: string | number = 'globale',
  searchText: string = ''
): Promise<PaginatedResponse<WrestlerStats> | ApiError> => {
  try {
    let path =
      year === 'globale'
        ? `api/stats/moreMatches?page=${page}`
        : `api/stats/moreMatches?year=${year}&page=${page}`;
    if (searchText) {
      path += `&name=${searchText}`;
    }
    return await doApi<PaginatedResponse<WrestlerStats>>(path, 'GET');
  } catch (error) {
    console.error('Error fetching most matches wrestlers stats:', error);
    return {
      error: true,
      message: 'Errore nel recupero delle statistiche dei wrestler con più match',
    };
  }
};

export const apiGetMostMatchesWrestlerWomanListStats = async (
  page: number = 1,
  year: string | number = 'globale',
  searchText: string = ''
): Promise<PaginatedResponse<WrestlerStats> | ApiError> => {
  try {
    let path =
      year === 'globale'
        ? `api/stats/moreMatchesWoman?page=${page}`
        : `api/stats/moreMatchesWoman?year=${year}&page=${page}`;
    if (searchText) {
      path += `&name=${searchText}`;
    }
    return await doApi<PaginatedResponse<WrestlerStats>>(path, 'GET');
  } catch (error) {
    console.error('Error fetching most matches wrestlers stats:', error);
    return {
      error: true,
      message: 'Errore nel recupero delle statistiche dei wrestler con più match',
    };
  }
};
